import React from 'react';

// Components
import Hero from '../components/sections/Hero.tsx';
import TestimonialsPreview from '../components/sections/TestimonialsPreview.tsx';
import ProcessOverview from '../components/sections/ProcessOverview.tsx';
import CTASection from '../components/sections/CTASection.tsx';
import TrustSignals from '../components/sections/TrustSignals.tsx';
import OneMin from '../components/sections/OneMin.tsx';

const Home: React.FC = () => {
  return (
    <div className="pt-20">
      {/* Hero Section */}
      <Hero />

      {/* Trust Signals */}
      <TrustSignals />

      {/* Services Overview */}
      {/* <ServicesOverview /> */}

      {/* One Min Section */}
      <OneMin />

      {/* About Preview */}
      {/* <AboutPreview /> */}

      {/* Process Overview */}
      <ProcessOverview />

      {/* Testimonials Preview */}
      <TestimonialsPreview />

      {/* CTA Section */}
      {/* <CTASection /> */}
    </div>
  );
};

export default Home;
